import { render, staticRenderFns } from "./SIntegerInput.vue?vue&type=template&id=5986a096&scoped=true&"
import script from "./SIntegerInput.vue?vue&type=script&lang=ts&"
export * from "./SIntegerInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5986a096",
  null
  
)

export default component.exports